import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const loanSearchModel = (patronId = "", studentId = "", shippingLocationId = "") => {
    return Object.assign({}, searchModel(patronId.toString(), "shippingLocationName", false, "shippingLocationName"), {
        shippingLocationId,
        studentId,
        patronId,
        ClearOrderSearch: clearOrderSearch,
        ApplySorting: applySorting,
    });
};

function clearOrderSearch(this: Record<string, unknown>) {
    this.shippingLocationId = "";
    this.studentId = "";
    this.patronId = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(loanSearchCriteria: Record<string, any>, loans: Record<string, any>[]) {
    if (isNullOrUndefined(loans) || isArrayNullOrEmpty(loans))
        return loans;

    return loans.sort(dynamicSort(loanSearchCriteria.sortByColumn as string, loanSearchCriteria.sortDescending as boolean));
}